<template>
    <div class="gty-tag" :id="defaultContainerId">
        <a :id="tooltipId">
            <span class="det_text fw-400">航司分配房须知</span>
            <img class="det_icon" src="https://resource.rcclchina.com.cn/tui2/info/webhao.png">
        </a>
        <b-tooltip :target="tooltipId" :container="containerId" triggers="hover" :placement="'right'"
        :boundary="'window'">
            <div>
              如预订航司分配房，请注意：
              <br/>该房型预订时无法确认具体房型、房间位置及房间号，且不支持自主选择。船司将根据航线实际库存情况进行房间分配，客人提交预订即视为接受船司分配结果。实际房型名称及房间号将在开航前更新显示于订单详情中，请及时关注相关更新信息，并打印最新版在线值船行程单。如客人对上述房型安排有顾虑，建议选择其他可确认房型以提升入住体验。
              <br/>特别提示：该房型最终分配的阳台房或套房可能有遮挡。
            </div>
        </b-tooltip>
    </div>
</template>

<script>
export default {
    name: "GtyTag",
    props: {
        index: {
            type: String,
            default () {
                return ""
            }
        },
        targetContainer: {
            type: String
        }
    },
    computed: {
         tooltipId () {
            if (!this.index || this.index == '') {
                return 'gtyTag_tooltip_' + (new Date()).getTime() + Math.random(1000)
            }
            return 'gtyTag_tooltip_' +this.index
        },
        containerId () {
            if (this.targetContainer && this.targetContainer.length > 0) {
                return this.targetContainer
            }
            return this.defaultContainerId
        },
        defaultContainerId () {
            if (!this.index || this.index == '') {
                return 'gtyTag_container_' + (new Date()).getTime() + Math.random(1000)
            }
            return 'gtyTag_container_' +this.index
        }
    }
}
</script>

<style lang="less" scoped>
.gty-tag {
    display: inline-block;
    cursor: pointer;
}
.det_text {
    color: #006ab9;
}
.det_icon {
    width: 16px;
    margin-top: -2px;
    margin-left: 5px;
}
</style>